import { useLazyQuery } from "@apollo/client";
import { currentTierIIReportingYear } from "encamp-shared/src/constants/tierii";
import { gql } from "generated-graphql";
import { TierIiReportVerifier } from "generated-graphql/graphql";
import { useCallback } from "react";

import { useReport } from "../useReport";

const VALIDATE_VERIFY_INPUT = gql(`
  query ValidateVerifyInput($id: ID!, $facilityId: ID!, $data: TierIIReportVerifier!, $reportingYear: Int!) {
    tierIIReportVerifyStepValidator(id: $id, facilityId: $facilityId, data: $data, reportingYear: $reportingYear) {
      ...issue
    }
  }
`);

export function useVerifyInputValidation() {
  const { data: reportDetailsData } = useReport();
  const [query] = useLazyQuery(VALIDATE_VERIFY_INPUT, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (input: TierIiReportVerifier) => {
      const { data } = await query({
        variables: {
          id: reportDetailsData?.tierIIReport.id ?? "",
          facilityId: reportDetailsData?.tierIIReport.facility.id ?? "",
          data: input,
          reportingYear:
            reportDetailsData?.tierIIReport.reportingYear ?? currentTierIIReportingYear,
        },
      });

      return data?.tierIIReportVerifyStepValidator ?? [];
    },
    // oxlint-disable-next-line exhaustive-deps -- Grandfathered in error. Future hooks should be exhaustive
    [query, reportDetailsData?.tierIIReport.facility.id, reportDetailsData?.tierIIReport.id]
  );
}
